export default "__VITE_ASSET__$13Md171__"